module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('div', {
    staticClass: "goship-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/goship.png"),
      "width": "200",
      "alt": "1Express"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Nền tảng giao hàng dành cho thương mại điện tử")])]), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Đăng nhập")]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.login,
      "label-width": "120px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.login.username),
      callback: function($$v) {
        _vm.$set(_vm.login, "username", $$v)
      },
      expression: "login.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu"
    },
    model: {
      value: (_vm.login.password),
      callback: function($$v) {
        _vm.$set(_vm.login, "password", $$v)
      },
      expression: "login.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item"
  }, [_c('el-button', {
    staticClass: "width-100",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitting,
      "native-type": "submit"
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("Đăng nhập")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-759ed8b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Login.vue
// module id = 647
// module chunks = 1